const nl = 'nl-NL';

export function formatDateTime(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  return new Intl.DateTimeFormat(nl, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat(nl).format(value);
}
